import { SwxTheme } from 'swx-atomic-component-lib'

const styles = {
  sliderContainer: `
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      margin-bottom: 0px; 
    }
  `,
  dialogTitle: `
    margin-top: 48px;
    margin-left: 48px;
    min-height: 20px;
    font-size: 16px;
    font-weight: 600;
    color: ${SwxTheme.palette['secondary-dark']};
  `,
  profileTab: `
    max-height: none;
    padding-bottom: 170px;
  `,
  dialogFooter: `
    height: 88px;
    background-color: ${SwxTheme.palette['secondary-light']}
    border-top: 1px solid ${SwxTheme.palette['secondary-mid']}
  `,
  dialogFooterContainer: `
    width: 100%;
    margin-top: 14px;
    align-items: center;
    justify-content: center;
    display: flex;
  `,
  dialogActionButtons: `
    width: 51%;
    float: right;
    justify-content: center;
    text-align: right;
    padding-right: 20px;
  `,
  dialogAllowedFiles: `
    display: flex;
    width: 49%;
    justify-content: center;
    text-align: left;
    font-size: 13px;
    padding-left: 20px;
  `,
  dialogBody: `
    align-items: center;
    justify-content: center;
    padding: 22px 26px 16px 26px
  `,
  cropperBox: `
    width: 275px;
    height: 275px;
    position: relative;
    background-color: rgba(0, 0, 0, 0.24);
    padding-top: 15px;
  `,
  cropperRound: `
    width: 244px;
    height: 244px;
    background-color: ${SwxTheme.palette.g300};
    border-radius: 50%;
    margin: 0 auto;
    display: block;
  `,
  actionButton: `
    width: 80px;
    height: 40px;
    margin-left: 4px;
    font-weight: 500;
  `,
  clearImage: `
    font-size: 12px;
    height: 16px;
    color: ${SwxTheme.palette.primary};
    margin-bottom: 22px;
    cursor: pointer;
  `,
  avatarError: `
    width: 100%;
    height: 12px;
    margin-bottom: 5px;
    color: ${SwxTheme.palette.highlight}; 
    text-align: center;
    font-size: 12px;
  `,
  commonTextfield: `
    background-color: ${SwxTheme.palette.white}; 
    width:36%;
    color: ${SwxTheme.palette.black}!important; 
  `,
  passwordStrengthMeterHolder: `
    width: 60%;
    margin-top: 40px;
    padding-right: 6px; 
  `,
  passwordStrengthMeter: `
    display: inline-block;
    width: calc(60% - 2px); 
  `,
  strengthMeterFill: `
    background: transparent;
    height: inherit;
    position: absolute;
    width: 0;
    border-radius: inherit;
    transition: width 0.5s ease-in-out, background 0.25s; 
    &[data-strength='0'] {
      width: 16.66667%;
      background: darkred; 
    }
    &[data-strength='1'] {
      width: 33.33334%;
      background: red; 
    }
    &[data-strength='2'] {
      width: 50.00001%;
      background: orange; 
    }
    &[data-strength='3'] {
      width: 66.66668%;
      background: yellowgreen; 
    }
    &[data-strength='4'] {
      width: 83.33335%;
      background: yellowgreen; 
    }
    &[data-strength='5'] {
      width: 100.00002%;
      background: green; 
    }
  `,
  weakDiv: `
    width: 50%;
    font-size: 11px;
    margin-top: -4px;
    font-weight: 600;
    color: ${SwxTheme.palette['secondary-dark']}; 
  `,
  strongDiv: `
    width: 50%;
    text-align: right;
    font-size: 11px;
    margin-top: -4px;
    font-weight: 600;
    color: ${SwxTheme.palette['secondary-dark']}; 
  `,
  passwordStrengthMeterResult: `
    margin-top: 24px;
    display: flex;
    color: ${SwxTheme.palette['secondary-dark']};
    font-size: 13px;
    align-items: flex-start;
  `,
  fullPasswordStrengthMeterResult: `
    margin-top: .438rem;
    display: flex;
    color: ${SwxTheme.palette['secondary-dark']};
    font-size: 13px;
    align-items: flex-start;
  `,
  passwordStrengthMeterTooltip: `
    display: inline-block;
    margin-right: 8px; 
  `,
  strengthMeter: `
    position: relative;
    height: 4px;
    background: ${SwxTheme.palette.g300};
    margin: 7px 0;
    border-radius: 2px; 
    &:before, &:after {
      content: '';
      height: inherit;
      background: transparent;
      display: block;
      border-color: ${SwxTheme.palette.white};
      border-style: solid;
      border-width: 0 0px 0;
      position: absolute;
      width: calc(20% + 0px);
      z-index: 10; 
    }
    &:before {
      left: calc(20% - 0px); 
    }
    &:after {
      right: calc(20% - 0px); 
    }
  `,
  fullStrengthMeter: `  
  width: 100% !important;
  > div > div {
    &[data-strength="0"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="1"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="2"] {
      background: ${SwxTheme.palette.highlight};
    }
    
    &[data-strength="3"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
    
    &[data-strength="4"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
    
    &[data-strength="5"] {
      background: ${SwxTheme.palette['primary-alt']};
    }
  }
`
}

export default styles
